import React, { Component } from "react";
import { Form, Input, Button, message, Icon } from "antd";
import "../../assets/css/content.min.css";
import {login} from '../../api/login'
class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        const res =  await login({...values,placeId:1})
        const result = res.data;
        const token = res.headers.authorization
        message.success("登录成功");
        sessionStorage.setItem("name",values.username);
        sessionStorage.setItem("level", result.level);
        sessionStorage.setItem("load", "1");
        sessionStorage.setItem("county", result.county);
        sessionStorage.setItem('@token',token)
        sessionStorage.setItem('tabkey','tabkey1')
        setTimeout(()=>{
          location.href = '/'
        },100)
      }
    });
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div
        className="register"
        // style={{ background: `url(${background[url]}) no-repeat` }}
      >
        <Form className="registerform" onSubmit={e => this.handleSubmit(e)}>
          <Form.Item>
            <div className="registerdiv">瑞安地名信息平台</div>
          </Form.Item>
          <Form.Item className="registeritem">
            {getFieldDecorator("username", {
              rules: [{ required: true, message: "请输入账号!" }]
            })(
              <Input
                prefix={
                  <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
                }
                placeholder="账号"
                className="registerinput"
              />
            )}
          </Form.Item>
          <Form.Item className="registeritem">
            {getFieldDecorator("password", {
              rules: [{ required: true, message: "请输入密码!" }]
            })(
              <Input
                prefix={
                  <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                }
                type="password"
                placeholder="密码"
                className="registerinput"
              />
            )}
          </Form.Item>
          <Form.Item style={{ textAlign: "center", marginTop: "20px" }}>
            <Button type="primary" htmlType="submit">
              登录
            </Button>
          </Form.Item>
        </Form>
      </div>
    );
  }
}
export default Form.create()(Register);
